/* eslint-disable no-return-assign */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-string-refs */
/* eslint-disable eqeqeq */
/* eslint-disable max-len */
import { debounce, get, orderBy, sortBy } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import * as queryString from 'query-string';
import React from 'react';
import { geocodeByAddress, geocodeByPlaceId, getLatLng } from 'react-places-autocomplete';
import { connect } from 'react-redux';

import AdWrapper from '../../components/Ads/AdWrapper';
import ClubCard from '../../components/cards/ClubCard';
import EventCard from '../../components/cards/EventCard';
import EventCardSponsored from '../../components/cards/EventCard/sponsored';
import JuniorCircuitEventCard from '../../components/cards/JuniorCircuitEventCard';
import PaidHitClubCard from '../../components/cards/PaidHitClubCard';
import PlayerCard from '../../components/cards/PlayerCard';
import SchoolCard from '../../components/cards/SchoolCard';
import TeamClubCard from '../../components/cards/TeamClubCard';
import withStatsig from '../../components/hocs/withStatsig';

import { searchAggregations } from '../../api';
import CollegeHSClubCard from '../../components/cards/CollegeHSClubCard';
import SearchPageReportsWelcomePopUp from '../../components/PopUps/WelcomePopUps/SearchPageReportsWelcomePopUp';
import UpgradeToProClubPopUp from '../../components/Upgrade/UpgradeToProClubPopUp';
import LearnMoreUtrCollegePopUp from '../../components/Upgrade/UpgradeToUtrCollege/LearnMoreUtrCollegePopUp';
import { ageSliderDictionary, collegeRecruitingPlayerAgeMax, collegeRecruitingPlayerAgeMin } from '../../utils/constants';
import { didNaturalSearchTransition } from '../../utils/naturalSearch';
import { SearchTypes, filterSearchEventTypes } from '../../utils/search';
import LocationFilter from './Filters/LocationFilter';

import {
    ClubFilters,
    CollegeCircuitFilters,
    CollegeFilters,
    FlexLeagueFilters,
    HighSchoolFilters,
    JuniorCircuitFilters,
    JuniorRegionalFilters,
    LeagueFilters,
    PaidHitClubFilters,
    PaidHitsFilters,
    PlayerFilters,
} from './FilterGroups';

import { AdultTeamClubsHeaderColumns, ClubsHeaderColumns, CollegeHeaderColumns, HighSchoolHeaderColumns, JuniorCircuitsHeaderColumns, PaidHitClubsHeaderColumns, PlayersHeaderColumns } from './SortableColumnHeaders';

import { getFeedPreferences } from '../../actions/settings-actions';
import { gtag } from '../../components/Analytics/gtag';
import UpgradeToPowerLinkV2 from '../../components/Upgrade/UpgradeToPowerLinkV2';
import { isFreeCollegeClub } from '../../utils/clubs';
import { ballTypes, sportTypeIds } from '../../utils/eventConstants';
import { getApiAxiosInstance } from '../../utils/network';
import { normalizePlayerRatingFilters } from '../../utils/normalizePlayerSearchFilters';
import { AdTypes } from '../../utils/types';
import { userIsClubAdminOrOwner, userIsProCollegeClubOwner } from '../../utils/user';
import { tomorrowDateGmt } from './Filters/FilterComponents/DateFilter';
import SportTypeFilter from './Filters/SportTypeFilter';
import PlayerSearchSavedStatusProvider from './PlayerSearchSavedStatusProvider';
import { isNewRosterModelEnabled } from '../../utils/statsig';
import styles from './search.scss';

const _ = { debounce, sortBy, get, orderBy };

class SearchResults extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filterModal: '',
            showSearchPageReportsWelcomePopUp: (props.location.search && props.location.search.indexOf('welcome_reports') > -1),
            availableToursList: [],
        };

        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleFilterClick = this.handleFilterClick.bind(this);
        this.handleTypeClick = this.handleTypeClick.bind(this);
        this.handleSeeAllClick = this.handleSeeAllClick.bind(this);
        this.handleDistanceClick = this.handleDistanceClick.bind(this);
        this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
        this.handleLinkClick = this.handleLinkClick.bind(this);
        this.applyLocationFilter = this.applyLocationFilter.bind(this);
        this.handleLocationChange = this.handleLocationChange.bind(this);
        this.handleLocationSelect = this.handleLocationSelect.bind(this);
        this.closeModals = this.closeModals.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.handleCurrentLocationClick = this.handleCurrentLocationClick.bind(this);
        this.onLocationRecieved = this.onLocationRecieved.bind(this);
        this.sortResults = this.sortResults.bind(this);
        this.handleFilterUpdate = this.handleFilterUpdate.bind(this);
        this.handleDistanceChange = this.handleDistanceChange.bind(this);
        this.handleHSGradYearClick = this.handleHSGradYearClick.bind(this);
        this.showLearnMoreUtrCollegePopup = this.showLearnMoreUtrCollegePopup.bind(this);
        this.handleProClubSuccess = this.handleProClubSuccess.bind(this);
        this.getFreeCollegeClubIdOptionsUpgrade = this.getFreeCollegeClubIdOptionsUpgrade.bind(this);
        this.filterBox = React.createRef();
        // Snapshot the NL sentinel at mount; componentDidUpdate uses it to
        // distinguish NL-driven type changes (skip the clear) from
        // user-driven ones (apply the clear). Assumes SearchResults is not
        // unmounted mid-NL-flow — a remount would re-initialize this to the
        // *current* sentinel value and the next type change would look
        // user-driven even if NL caused it.
        this.lastSeenNlSentinel = props.naturalSearchAppliedSentinel ?? 0;
    }

    async componentDidMount() {
        const { user, feedPreferences, isFeedPreferencesLoading } = this.props.auth || {};
        const shouldFetchFeedPreferences = user && !feedPreferences && !isFeedPreferencesLoading;

        if (shouldFetchFeedPreferences) {
            this.props.getFeedPreferences();
        }

        document.addEventListener('mousedown', this.handleClickOutside);
        let url = this.props.location.search;
        let encodedValue;
        let eventLabel;
        if (url.indexOf('NorCal&PNW') !== -1) {
            eventLabel = 'NorCal&PNW';
            encodedValue = encodeURIComponent(eventLabel);
            url = url.replace('NorCal&PNW', encodedValue);
        }
        if (url.indexOf('SoCal&AZ') !== -1) {
            eventLabel = 'SoCal&AZ';
            encodedValue = encodeURIComponent(eventLabel);
            url = url.replace('SoCal&AZ', encodedValue);
        }
        const parsed = queryString.parse(url);
        const filterSportTypes = this.props.search.filters.sportTypes;
        const userSportTypes = user
            ? { tennis: feedPreferences?.showTennisContent, pickleball: feedPreferences?.showPickleballContent }
            : { tennis: true, pickleball: true };
        const sportTypes = filterSportTypes
            ? { tennis: filterSportTypes.tennis, pickleball: filterSportTypes.pickleball }
            : userSportTypes;
        const filters = {
            type: this.props.search.filters.type || 'players',
            hsGradYears: {},
            eventTypes: {},
            eventUtrTypes: {},
            eventTeamTypes: {},
            genders: {},
            tours: this.props.search.filters.tours || {},
            eventTags: {},
            eventRegions: {},
            ballTypes: this.props.search.filters.ballTypes || {},
            sportTypes,
            regionSearch: this.props.search.filters.type === 'juniorCircuits',
        };

        const { coreUI } = this.props;
        const playersLabel = 'players';
        const clubsLabel = 'clubs';
        const filterType = filters?.type || '';
        if ((filterType === 'events' || filterType === playersLabel || filterType === clubsLabel) && Object.keys(filters.sportTypes).length === 0) {
            const sportTypeList = coreUI.types?.tms?.sportTypes || [];

            if (feedPreferences?.showTennisContent) {
                const tennisSportType = sportTypeList.find(type => type.id === sportTypeIds.TENNIS);
                if (tennisSportType) {
                    filters.sportTypes[tennisSportType.value] = true;
                }
            }

            if (feedPreferences?.showPickleballContent) {
                const pickleballSportType = sportTypeList.find(type => type.id === sportTypeIds.PICKLEBALL);
                if (pickleballSportType) {
                    filters.sportTypes[pickleballSportType.value] = true;
                }
            }
        }

        if (!Object.keys(parsed).length) {
            filters.utrFitPosition = '6';
            filters.startDate = tomorrowDateGmt;
        }
        const isNlOnlyKey = (k) => k === 'nlq' || k === 'nlc' || k === 'nlg';
        Object.keys(parsed).forEach(key => {
            if (isNlOnlyKey(key)) {
                return;
            }
            if (key == 'query') {
                this.props.updateSearchQuery(parsed[key]);
            } else if (key != 'query') {
                if (key == 'location') {
                    filters.locationInputValue = parsed[key];
                }
                if (key == 'gradYearHs') {
                    if (userIsProCollegeClubOwner(user)) {
                        const gradYears = parsed[key].split(',');
                        gradYears.forEach(gradYear => {
                            filters.hsGradYears[gradYear] = true;
                        });
                    }
                } else if (key == 'tours') {
                    const tours = parsed[key].split(',');
                    tours.forEach(tour => {
                        filters.tours[decodeURI(tour)] = true;
                    });
                } else if (key == 'eventTypes') {
                    const eventTypes = parsed[key].split(',');
                    eventTypes.forEach(eventType => {
                        filters.eventTypes[decodeURI(eventType)] = true;
                    });
                } else if (key == 'eventRegions') {
                    const eventRegions = parsed[key].split(',');
                    eventRegions.forEach(eventRegion => {
                        filters.eventRegions[decodeURI(eventRegion)] = true;
                    });
                } else if (key == 'eventTags') {
                    const eventTags = parsed[key].split(',');
                    eventTags.forEach(eventTag => {
                        filters.eventTags[decodeURI(eventTag)] = true;
                    });
                } else if (key == 'eventUtrTypes') {
                    const eventUtrTypes = parsed[key].split(',');
                    eventUtrTypes.forEach(eventUtrType => {
                        filters.eventUtrTypes[decodeURI(eventUtrType)] = true;
                    });
                } else if (key == 'genders') {
                    const genders = parsed[key].split(',');
                    genders.forEach(gender => {
                        filters.genders[decodeURI(gender)] = true;
                    });
                } else if (key == 'eventTeamTypes') {
                    const eventTeamTypes = parsed[key].split(',');
                    eventTeamTypes.forEach(eventTeamType => {
                        filters.eventTeamTypes[decodeURI(eventTeamType)] = true;
                    });
                } else if (key == 'utrMin' || key == 'utrMax') {
                    filters[key] = parseInt(parsed[key]);
                } else if (key == 'lat' || key == 'lng') {
                    const coord = parseFloat(parsed[key]);
                    filters[key] = Number.isFinite(coord) ? coord : null;
                } else if (key == 'ageMin' || key == 'ageMax') {
                    if (userIsProCollegeClubOwner(user)) {
                        filters[key] = parseInt(parsed[key]);
                    }
                } else if (key == 'ballTypes') {
                    const ballTypes = parsed[key].split(',');
                    ballTypes.forEach(ballType => {
                        filters.ballTypes[decodeURI(ballType)] = true;
                    });
                } else if (key == 'sportTypes') {
                    const sportTypes = {};
                    parsed[key].split(',').forEach(sportType => {
                        sportTypes[decodeURI(sportType)] = true;
                    });
                    filters[key] = sportTypes;
                } else {
                    filters[key] = parsed[key];
                }
            }
        });
        // HUB-1178: a URL-hydrated landing (iOS-shaped link / stale bookmark) can carry the
        // pickleball-only rating default (doubles + UTR-P ceiling of 10) on a tennis-inclusive
        // search, which clips the tennis doublesUtr field and drops the top players. Normalize
        // it back to the tennis defaults before it reaches search state.
        await this.props.applySearchFilters(normalizePlayerRatingFilters(filters), true);
        await this.getTourAggregationList();
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.location.search !== this.props.location.search) {
            const prevParsed = queryString.parse(prevProps.location.search);
            const currentParsed = queryString.parse(this.props.location.search);
            const user = this.props?.auth?.user;

            if (this.props.location.search && this.props.location.search.indexOf('welcome_reports') > -1) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    showSearchPageReportsWelcomePopUp: true,
                });
            }

            if (prevParsed.type !== currentParsed.type && currentParsed.type) {
                const nlSentinel = this.props.naturalSearchAppliedSentinel ?? 0;
                const causedByNl = didNaturalSearchTransition(this.lastSeenNlSentinel, nlSentinel);
                this.lastSeenNlSentinel = nlSentinel;
                if (causedByNl) {
                    return;
                }
                this.clearFilters('everythingButType');
                this.props.applySearchFilters({
                    type: currentParsed.type,
                }, true);

                if (user && currentParsed.type === 'clubs') {
                    this.props.applySearchFilters({
                        locationInputValue: user.location.display,
                        locationCountryName: '',
                        locationStateName: '',
                        distance: '50mi',
                        location: user.location.display,
                        lat: user.location.latLng[0],
                        lng: user.location.latLng[1],
                    }, true);
                }

                this.setState({
                    filterModal: '',
                });
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    onLocationRecieved(location) {
        const filterInputs = this.props.search.filterInputs || {};
        this.props.applySearchFilters({
            ...this.props.search.geocoded,
            location: location.location,
            distance: filterInputs.distance || '50mi',
            locationInputValue: location.location || '',
            locationCountryName: '',
            locationStateName: '',
        }, true);
        this.setState({
            filterModal: '',
        });
    }

    getFreeCollegeClubIdOptionsUpgrade() {
        const { user } = this.props.auth;

        const clubOwnerAdminFreeCollegeClubs = user.clubMemberships.filter((clubMembership) => {
            return isFreeCollegeClub(clubMembership.tierTypeName) && userIsClubAdminOrOwner(clubMembership);
        });

        if (clubOwnerAdminFreeCollegeClubs.length > 0) {
            return clubOwnerAdminFreeCollegeClubs.map((clubMembership) => {
                return {
                    value: clubMembership.clubId,
                    label: clubMembership.name,
                };
            });
        }
        return null;
    }

    async getTourAggregationList() {
        const filters = this.props.search.filters || {};
        const filterType = filters?.type || '';

        if (filterType !== 'events') {
            return;
        }

        const aggregationTerm = 'eventTours.name';
        const aggregations = {
            filter: ['eventTours.tourStatusId:!2'],
            terms: [{
                term: aggregationTerm,
            }],
        };
        const result = await searchAggregations(getApiAxiosInstance(), 'events', aggregations);
        this.setState({
            // eslint-disable-next-line react/no-unused-state
            availableToursList: result.data[aggregationTerm],
        });
    }

    closeModals() {
        if (this.state.filterModal) {
            this.clearFilters(this.state.filterModal);
        }
        this.setState({
            filterModal: '',
        });
    }

    handleClickOutside(event) {
        if (this.filterBox && !this.filterBox.contains(event.target)) {
            this.undoFilterChange();
            this.setState({
                filterModal: '',
            });
        }
    }

    handleFilterClick(type) {
        gtag('search-filter', {
            category: 'Search Filter',
            context: `${type} Filter click`,
            location: 'Search Results CTA',
        });

        this.setState(prevState => {
            const filterModal = prevState.filterModal == type ? '' : type;
            if (filterModal !== '') { // only track on open
                gtag('search-filter', {
                    category: 'Search Filter',
                    context: `Search Filter - ${this.props.search.filters.type}`,
                    location: `Search Results CTA, open - ${type}`,
                });
            }

            return {
                filterModal,
            };
        });
    }

    clearFilters(type, reSearch) {
        this.setState({
            filterModal: '',
            // locationStateNameList: []
        });
        this.props.clearFilters(type, reSearch);
        // HUB-1178: only apply the pickleball UTR-P rating default (doubles + ceiling of 10)
        // when the search is pickleball-ONLY. With tennis also selected, the max-10 ceiling
        // clips the tennis doublesUtr field and drops the top players from a general search.
        const sportTypes = this.props.search?.filterInputs?.sportTypes;
        if (sportTypes?.pickleball && !sportTypes?.tennis) {
            this.handleFilterUpdate({
                utrTeamType: 'doubles',
                utrMin: 1,
                utrMax: 10,
            });
        } else {
            this.handleFilterUpdate({
                utrTeamType: 'singles',
                utrMin: 1,
                utrMax: 16,
            });
        }
    }

    handleSeeAllClick(type) {
        this.props.applySearchFilters({
            type,
        });
    }

    undoFilterChange() {
        this.props.undoFilterChange();
    }

    handleFilterUpdate(props, update) {
        // only updates filter input field values, input field values have no effect on filter state, these changes don't get submitted, users have to click the apply button first
        // Filter input state is stored in 'filterInputs'

        if (!update || update === 'filterInput') {
            if (!props?.sportTypes?.tennis && !!props?.sportTypes?.pickleball) {
                this.props.changeFilterInputs({
                    ...props,
                    hsGradYears: {},
                    ageMin: '',
                    ageMax: '',
                });
            } else {
                this.props.changeFilterInputs(props);
            }
        }
        // updates the filter state directly, but the updated state doesn't get submitted to the api yet
        // Filter state is stored in 'filters'
        if (update === 'filterState') {
            this.props.applySearchFilters(props);
        }
        // updates the filter state directly, and the updated state gets submitted (re-search)
        if (update === 'submit') {
            this.props.applySearchFilters(props, true);
            this.setState({
                filterModal: '',
            });
        }
    }

    handleDistanceChange(distance) {
        this.props.changeFilterInputs({
            distance: `${distance}mi`,
        });
    }

    // Location filter modal
    handleLocationChange(locationInputValue) {
        this.props.changeFilterInputs({
            locationInputValue,
            locationCountryName: '',
            locationStateName: '',
            // distance: '',
            location: '',
            lat: null,
            lng: null,
        });
    }

    applyLocationFilter() {
        const filters = this.props.search.filterInputs || {};
        const { locationInputValue } = filters;
        if (!((filters.location && filters.lat && filters.lng && filters.distance) || (filters.locationCountryName || filters.locationStateName))) {
            geocodeByAddress(locationInputValue)
                .then(async (results) => {
                    const latLng = await getLatLng(results[0]);
                    return { results, latLng };
                })
                .then(({ results, latLng }) => {
                    console.log('results', results, 'latLng', latLng);
                    if (results[0].types[0] == 'country') {
                        this.props.changeFilterInputs({
                            locationCountryName: results[0].address_components[0].long_name,
                            locationStateName: '',
                            distance: filters.distance || '50mi',
                            location: '',
                            locationInputValue: locationInputValue || '',
                            lat: null,
                            lng: null,
                        });
                    } else if (results[0].types[0] == 'administrative_area_level_1') {
                        this.props.changeFilterInputs({
                            locationCountryName: results[0].address_components[1].long_name,
                            locationStateName: results[0].address_components[0].long_name,
                            distance: filters.distance || '50mi',
                            location: '',
                            locationInputValue: locationInputValue || '',
                            lat: null,
                            lng: null,
                        });
                    } else {
                        this.props.changeFilterInputs({
                            lat: latLng.lat,
                            lng: latLng.lng,
                            location: locationInputValue,
                            distance: filters.distance || '50mi',
                            locationInputValue: locationInputValue || '',
                            locationCountryName: '',
                            locationStateName: '',
                        });
                    }
                    this.handleFilterSubmit();
                })
                .catch(error => console.error('geocodeByAddress error', error));
        } else {
            this.handleFilterSubmit();
        }
    }

    handleLocationSelect(location, placeId) {
        const filters = this.props.search.filterInputs || {};
        if (location) {
            const geocodePromise = placeId ? geocodeByPlaceId(placeId) : geocodeByAddress(location);
            geocodePromise
                .then(async (results) => {
                    const latLng = await getLatLng(results[0]);
                    return { results, latLng };
                })
                .then(({ results, latLng }) => {
                    console.log('results', results, 'latLng', latLng);
                    if (results[0].types[0] == 'country') {
                        this.props.changeFilterInputs({
                            locationCountryName: results[0].address_components[0].long_name,
                            locationStateName: '',
                            distance: filters.distance || '50mi',
                            location: '',
                            locationInputValue: location,
                            lat: null,
                            lng: null,
                        });
                    } else if (results[0].types[0] == 'administrative_area_level_1') {
                        this.props.changeFilterInputs({
                            locationCountryName: results[0].address_components[1].long_name,
                            locationStateName: results[0].address_components[0].long_name,
                            distance: filters.distance || '50mi',
                            location: '',
                            locationInputValue: location,
                            lat: null,
                            lng: null,
                        });
                    } else {
                        this.props.changeFilterInputs({
                            lat: latLng.lat,
                            lng: latLng.lng,
                            location,
                            distance: filters.distance || '50mi',
                            locationInputValue: location,
                            locationCountryName: '',
                            locationStateName: '',
                        });
                    }
                })
                .catch(error => console.error('geocodeByAddress error', error));
        }
    }

    handleDistanceClick(distance) {
        this.props.changeFilterInputs({
            distance,
            locationCountryName: '',
            locationStateName: '',
        });
    }

    handleCurrentLocationClick() {
        if (this.props.fetchCurrentLocation) {
            this.props.fetchCurrentLocation(this.onLocationRecieved);
        }
    }

    // Type filter modal
    handleTypeClick(type) {
        console.log('handleTypeClick', type);
        this.clearFilters('everythingButType');
        this.props.applySearchFilters({
            type,
        }, true);
        this.setState({
            filterModal: '',
        });
    }

    // High School Grad Year modal
    handleHSGradYearClick(value) {
        console.log('handleHSGradYearClick', value);

        const hsGradYearsToApply = {
            ...this.props.search.filterInputs.hsGradYears,
            [value]: !this.props.search.filterInputs.hsGradYears[value],
        };

        this.props.changeFilterInputs({
            hsGradYears: hsGradYearsToApply,
            ageMin: collegeRecruitingPlayerAgeMin,
            ageMax: collegeRecruitingPlayerAgeMax,
        });
    }

    handleFilterSubmit() {
        gtag('search-filter', {
            category: 'Search Filter',
            context: `Filter apply - ${JSON.stringify(this.props.search.filters)}`,
            location: 'Search Results CTA',
        });
        this.props.updateFiltersApplied(true);
        this.setState({
            filterModal: '',
        });
    }

    handleLinkClick() {
        this.props.clearGlobalSearch(true);
    }

    sortResults(type, field, direction) {
        console.log('sortResults', type, field, direction);
        this.props.setTypeSorting({ type, field, direction });
    }

    handleProClubSuccess() {
        setTimeout(() => {
            window.location.reload();
            // this.setState({showProClubPopup: false})
        }, 3000);
    }

    showLearnMoreUtrCollegePopup() {
        this.setState({ showLearnMoreUtrCollegePopup: true });
    }

    render() {
        const { search, auth, coreUI, eventResultsOptions, sendMessage, isMobileWidth, isTabletWidth, playerSearchConfig, eventSearchConfig, clubSearchConfig, showAds, featureGates, checkGate } = this.props;
        const { players, highSchools, colleges, clubs, events, camps, flexLeagues, teamLeagues, proTennisTour, juniorCircuits, juniorRegionals, collegeCircuits, adultTeamClubs, paidHits, paidHitClubs, isLoadingType, searchPageType } = this.props.search;
        const baseSearchTypes = coreUI?.types?.search ?? null;
        const searchTypes = baseSearchTypes;
        searchTypes.eventTypes = filterSearchEventTypes(baseSearchTypes.eventTypes);

        searchTypes.ballTypes = ballTypes;
        searchTypes.sportTypes = coreUI?.types?.tms?.sportTypes;
        const isDinglesEnabled = checkGate(featureGates.DINGLES);
        const isRostersRolloutEnabled = checkGate(featureGates.ROSTERS_ROLLOUT);
        const isHsNewRosterModel = isNewRosterModelEnabled(checkGate, featureGates, false);
        searchTypes.eventTeamTypes = baseSearchTypes.eventTeamTypes.filter((teamType) => {
            if (teamType.id === 3) {
                return isDinglesEnabled;
            }

            return true;
        });
        const clubSubTypes = coreUI?.types?.clubSubTypes ?? null;
        const eventsWithPrismicContent = [...events.hits];
        const flexLeaguesWithPrismicContent = [...flexLeagues.hits];
        const teamLeaguesWithPrismicContent = [...teamLeagues.hits];
        const proTennisTourWithPrismicContent = [...proTennisTour.hits];
        const highSchoolsWithPrismicContent = [...highSchools.hits];
        const clubsWithPrismicContent = [...clubs.hits];
        const playersWithPrismicContent = [...players.hits];
        const collegesWithPrismicContent = [...colleges.hits];
        const adultTeamClubsWithPrismicContent = [...adultTeamClubs.hits];
        const paidHitsWithPrismicContent = [...paidHits.hits];
        const paidHitClubsWithPrismicContent = [...paidHitClubs.hits];
        const juniorCircuitsWithPrismicContent = [...juniorCircuits.hits];
        const collegeCircuitsWithPrismicContent = [...collegeCircuits.hits];
        const juniorRegionalsWithPrismicContent = [...juniorRegionals.hits];
        const campsWithPrismicContent = camps?.hits ? [...camps.hits] : [];

        const filters = this.props.search.filters || {};
        const filterInputs = this.props.search.filterInputs || {};
        const hideFilters = _.get(this, 'props.options.hideFilters') || {};

        const user = this.props?.auth?.user;
        const isPowerUser = this.props?.auth?.user?.isPowered;
        const filterType = filters?.type || '';
        const isNotLoading = this.props.search.isLoading && !this.props.search.isLoadingType;

        const searchIsIdle = this.props.search.pageLoadedOnce && !this.props.search.isLoading;
        const searchHasNotStarted = !this.props.search.pageLoadedOnce && !this.props.search.isLoading;

        const isCampsWithNoResults = (filterType, camps) => {
            return filterType === 'camps' && camps !== undefined && !camps.total && searchIsIdle;
        };

        const isCampsWithResults = (filterType, camps) => {
            return (!filterType || filterType === 'camps') && camps && camps.total > 0 && !isNotLoading;
        };

        const eventsAgeDisplay = (ageMin = 0, ageMax = 23) => {
            if (ageMin == 0 && ageMax == Object.keys(ageSliderDictionary).length - 1) {
                return 'All';
            }
            if (ageMin == ageMax && ageMin == 0) {
                return `${ageSliderDictionary[1]} and Under`;
            }
            if (ageMin == ageMax && ageMax == Object.keys(ageSliderDictionary).length - 1) {
                return `${ageSliderDictionary[ageMax - 1]} and Over`;
            }
            if (ageMin === ageMax) {
                return `Age ${ageSliderDictionary[ageMin]} Only`;
            }
            if (ageMin == 0) {
                return `${ageSliderDictionary[ageMax]} and Under`;
            }
            if (ageMax == Object.keys(ageSliderDictionary).length - 1) {
                return `${ageSliderDictionary[ageMin]} and Over`;
            }
            return `${ageSliderDictionary[ageMin]} to ${ageSliderDictionary[ageMax]}`;
        };

        const isAtSearchLimit = (filterTypeString) => {
            switch (filterTypeString) {
                case 'clubs':
                    return clubs?.hits?.length >= Math.min(clubs.total, clubs.totalAllowed);
                case 'players':
                    return players?.hits?.length >= Math.min(players.total, players.totalAllowed);
                case 'events':
                    return events?.hits?.length >= Math.min(events.total, events.totalAllowed);
                case 'colleges':
                    return colleges?.hits?.length >= Math.min(colleges.total, colleges.totalAllowed);
                case 'highSchools':
                    return highSchools?.hits?.length >= Math.min(highSchools.total, highSchools.totalAllowed);
                case 'flexLeagues':
                    return flexLeagues?.hits?.length >= Math.min(flexLeagues.total, flexLeagues.totalAllowed);
                case 'teamLeagues':
                    return teamLeagues?.hits?.length >= Math.min(teamLeagues.total, teamLeagues.totalAllowed);
                case 'proTennisTour':
                    return proTennisTour?.hits?.length >= Math.min(proTennisTour.total, proTennisTour.totalAllowed);
                case 'adultTeamClubs':
                    return adultTeamClubs?.hits?.length >= Math.min(adultTeamClubs.total, adultTeamClubs.totalAllowed);
                case 'paidHits':
                    return paidHits?.hits?.length >= Math.min(paidHits.total, paidHits.totalAllowed);
                case 'paidHitClubs':
                    return paidHitClubs?.hits?.length >= Math.min(paidHitClubs.total, paidHitClubs.totalAllowed);
                case 'juniorCircuits':
                    return juniorCircuits?.hits?.length >= Math.min(juniorCircuits.total, juniorCircuits.totalAllowed);
                case 'collegeCircuits':
                    return collegeCircuits?.hits?.length >= Math.min(collegeCircuits.total, collegeCircuits.totalAllowed);
                case 'juniorRegionals':
                    return juniorRegionals?.hits?.length >= Math.min(juniorRegionals.total, juniorRegionals.totalAllowed);
                case 'camps':
                    return camps?.hits?.length >= Math.min(camps.total, camps.totalAllowed);
                default:
                    return false;
            }
        };

        const filtersAreActive = (
            // location (all types)
            (filters.lat && filters.lng && filters.distance) ||
            (filters.locationCountryName || filters.locationStateName) ||
            // gender (players/events/colleges/hs)
            filters.gender ||
            // utr (players/events)
            filters.utrMin > 1 || filters.utrMax < 16 || filters.utrType || filters.utrTeamType || filters.utrReliability ||
            // college/div/conf (players/colleges)
            filters.college || filters.division || filters.conference ||
            // player filters
            filters.primaryTag || filters.ageTag || (filters.ageMin || filters.ageMax) || filters.nationality || (filters.hsGradYears && Object.values(filters.hsGradYears).indexOf(true) > -1) ||
            // event filters
            (filters.startDate && moment(filters.startDate).diff(new Date(), 'days') != 0) || filters.endDate ||
            (filters.tours && Object.values(filters.tours).indexOf(true) > -1) ||
            (filters.eventTypes && Object.values(filters.eventTypes).indexOf(true) > -1) ||
            (filters.ballTypes && Object.values(filters.ballTypes).indexOf(true) > -1) ||
            (filters.sportTypes && Object.values(filters.sportTypes).indexOf(true) > -1) ||
            (filters.eventRegions && Object.values(filters.eventRegions).indexOf(true) > -1) ||
            (filters.eventUtrTypes && Object.values(filters.eventUtrTypes).indexOf(true) > -1) ||
            (filters.prizeMoneyMin && filters.prizeMoneyMin > 1) ||
            (filters.prizeMoneyMax && filters.prizeMoneyMax < searchTypes.prizeMoneyValues.length) ||
            (filters.eventTeamTypes && Object.values(filters.eventTeamTypes).indexOf(true) > -1) ||
            (filters.genders && Object.values(filters.genders).indexOf(true) > -1) /* filters.hasPrizeMoney */ ||
            // college filters
            filters.publicPrivate || filters.utrFitRating);

        let prismicContentPage = '';
        switch (searchPageType) {
            case 'search':
                prismicContentPage = 'search';
                break;
            case 'playersTour':
                prismicContentPage = 'openseries';
                break;
            case 'ITASummerCircuitTour':
                prismicContentPage = 'itasummercircuit';
                break;
            default:
                break;
        }
        if (search?.prismicContent?.[prismicContentPage]?.length) {
            const ads = _.orderBy(search.prismicContent[prismicContentPage], ['index'], ['asc']);
            let eventAds = 0;
            let playerAds = 0;
            let clubAds = 0;
            let collegeAds = 0;
            let highSchoolAds = 0;
            let adultTeamClubsAds = 0;
            let paidHitClubsAds = 0;
            const campsAds = 0;
            ads.forEach((ad) => {
                if (ad.is_active) {
                    switch (ad.type) {
                        case 'events':
                            if (events.hits.length) {
                                if (eventAds < 1 || (events.hits.length > 5 && eventAds >= 1)) {
                                    eventsWithPrismicContent.splice((ad.index ? parseInt(ad.index) - 1 : 0), 0, { ...ad, isSponsored: true });
                                    eventAds++;
                                }
                            }
                            if (flexLeagues.hits.length) {
                                if (eventAds < 1 || (flexLeagues.hits.length > 5 && eventAds >= 1)) {
                                    flexLeaguesWithPrismicContent.splice((ad.index ? parseInt(ad.index) - 1 : 0), 0, { ...ad, isSponsored: true });
                                    eventAds++;
                                }
                            }
                            if (teamLeagues.hits.length) {
                                if (eventAds < 1 || (teamLeagues.hits.length > 5 && eventAds >= 1)) {
                                    teamLeaguesWithPrismicContent.splice((ad.index ? parseInt(ad.index) - 1 : 0), 0, { ...ad, isSponsored: true });
                                    eventAds++;
                                }
                            }
                            if (proTennisTour.hits.length) {
                                if (eventAds < 1 || (proTennisTour.hits.length > 5 && eventAds >= 1)) {
                                    proTennisTourWithPrismicContent.splice((ad.index ? parseInt(ad.index) - 1 : 0), 0, { ...ad, isSponsored: true });
                                    eventAds++;
                                }
                            }
                            if (paidHits.hits.length) {
                                if (eventAds < 1 || (paidHits.hits.length > 5 && eventAds >= 1)) {
                                    paidHitsWithPrismicContent.splice((ad.index ? parseInt(ad.index) - 1 : 0), 0, { ...ad, isSponsored: true });
                                    eventAds++;
                                }
                            }
                            if (juniorCircuits.hits.length) {
                                if (eventAds < 1 || (juniorCircuits.hits.length > 5 && eventAds >= 1)) {
                                    juniorCircuitsWithPrismicContent.splice((ad.index ? parseInt(ad.index) - 1 : 0), 0, { ...ad, isSponsored: true });
                                    eventAds++;
                                }
                            }
                            if (collegeCircuits.hits.length) {
                                if (eventAds < 1 || (collegeCircuits.hits.length > 5 && eventAds >= 1)) {
                                    collegeCircuitsWithPrismicContent.splice((ad.index ? parseInt(ad.index) - 1 : 0), 0, { ...ad, isSponsored: true });
                                    eventAds++;
                                }
                            }
                            if (juniorRegionals.hits.length) {
                                if (eventAds < 1 || (juniorRegionals.hits.length > 5 && eventAds >= 1)) {
                                    juniorRegionalsWithPrismicContent.splice((ad.index ? parseInt(ad.index) - 1 : 0), 0, { ...ad, isSponsored: true });
                                    eventAds++;
                                }
                            }
                            break;
                        case 'camps':
                            if (camps.hits.length) {
                                if (campsAds < 1 || (camps.hits.length > 5 && campsAds >= 1)) {
                                    campsWithPrismicContent.splice((ad.index ? parseInt(ad.index) - 1 : 0), 0, { ...ad, isSponsored: true });
                                    eventAds++;
                                }
                            }
                            break;
                        case 'players':
                            if (players.hits.length && user) {
                                if (playerAds < 1 || (players.hits.length > 5 && playerAds >= 1)) {
                                    playersWithPrismicContent.splice((ad.index ? parseInt(ad.index) - 1 : 0), 0, { ...ad, isSponsored: true });
                                    playerAds++;
                                }
                            }
                            break;
                        case 'clubs':
                            if (clubs.hits.length) {
                                if (clubAds < 1 || (clubs.hits.length > 5 && clubAds >= 1)) {
                                    clubsWithPrismicContent.splice((ad.index ? parseInt(ad.index) - 1 : 0), 0, { ...ad, isSponsored: true });
                                    clubAds++;
                                }
                            }
                            break;
                        case 'colleges':
                            if (colleges.hits.length) {
                                if (collegeAds < 1 || (colleges.hits.length > 5 && collegeAds >= 1)) {
                                    collegesWithPrismicContent.splice((ad.index ? parseInt(ad.index) - 1 : 0), 0, { ...ad, isSponsored: true });
                                    collegeAds++;
                                }
                            }
                            break;
                        case 'highSchools':
                            if (highSchools.hits.length) {
                                if (highSchoolAds < 1 || (highSchools.hits.length > 5 && highSchoolAds >= 1)) {
                                    highSchoolsWithPrismicContent.splice((ad.index ? parseInt(ad.index) - 1 : 0), 0, { ...ad, isSponsored: true });
                                    highSchoolAds++;
                                }
                            }
                            break;
                        case 'adultTeamClubs':
                            if (adultTeamClubs.hits.length) {
                                if (adultTeamClubsAds < 1 || (adultTeamClubs.hits.length > 5 && adultTeamClubsAds >= 1)) {
                                    // if ad index present insert at index - 1 or at 0
                                    adultTeamClubsWithPrismicContent.splice((ad.index ? parseInt(ad.index) - 1 : 0), 0, { ...ad, isSponsored: true });
                                    adultTeamClubsAds++;
                                }
                            }
                            break;
                        case 'paidHitClubs':
                            if (paidHitClubs.hits.length) {
                                if (paidHitClubsAds < 1 || (paidHitClubs.hits.length > 5 && paidHitClubsAds >= 1)) {
                                    // if ad index present insert at index - 1 or at 0
                                    paidHitClubsWithPrismicContent.splice((ad.index ? parseInt(ad.index) - 1 : 0), 0, { ...ad, isSponsored: true });
                                    paidHitClubsAds++;
                                }
                            }
                            break;
                        default:
                            break;
                    }
                }
            });
        }

        const displayCollegeRecruitingValues = !!(user && userIsProCollegeClubOwner(user) && ((filters.ageMin || filters.ageMax) || (filters.hsGradYears && Object.values(filters.hsGradYears).indexOf(true) > -1)));

        const commonFilterProps = {
            _this: this,
            state: this.state,
            search,
            userLoggedIn: !!user,
            hideFilters,
            isPowerUser,
            filterInputs,
            searchTypes,
            handleFilterClick: this.handleFilterClick,
            clearFilters: this.clearFilters,
            closeModals: this.closeModals,
            handleFilterSubmit: this.handleFilterSubmit,
            handleFilterUpdate: this.handleFilterUpdate,
            auth,
            filterType,
            availableToursList: this.state.availableToursList,
        };

        const locationFilterNotAllowedEvents = ['teamLeagues', 'proTennisTour'];

        const showAdultTeamClubs = (!filterType || filterType == 'adultTeamClubs') &&
            adultTeamClubs?.total > 0 &&
            !isNotLoading;
        const showNoAdultTeamClubsMessage = filterType == 'adultTeamClubs' &&
            !adultTeamClubs.total &&
            searchIsIdle;
        const showLoadMoreAdultTeamClubs = filterType == 'adultTeamClubs' && !isAtSearchLimit(filterType);

        const showPaidHitClubs = (!filterType || filterType == 'paidHitClubs') &&
            paidHitClubs?.total > 0 &&
            !isNotLoading;
        const showNoPaidHitClubsMessage = filterType == 'paidHitClubs' &&
            !paidHitClubs.total &&
            searchIsIdle;
        const showLoadMorePaidHitClubs = filterType == 'paidHitClubs' && !isAtSearchLimit(filterType);
        const juniorCircuitsLabel = 'juniorCircuits';
        const playersLabel = 'players';
        const eventsLabel = 'events';
        const collegesLabel = 'colleges';
        const clubsLabel = 'clubs';
        const collegeCircuitsLabel = 'collegeCircuits';
        const juniorRegionalsLabel = 'juniorRegionals';
        const shouldShowSportTypeFilter = (filterType === SearchTypes.EVENTS || filterType === SearchTypes.FLEX_LEAGUES || filterType === playersLabel || filterType === SearchTypes.CLUBS);
        const isCollegeCircuits = !filterType || filterType === collegeCircuitsLabel;
        const hasCollegeCircuits = collegeCircuits && collegeCircuits.total > 0;
        const isSearchLoading = this.props.search.isLoading;
        const isSearchLoadingType = this.props.search.isLoadingType;
        const isJuniorRegionals = !filterType || filterType === juniorRegionalsLabel;
        const hasJuniorRegionals = juniorRegionals && juniorRegionals.total > 0;
        const showUpgradeToPowerLink = user && !isPowerUser && filterType === playersLabel && isAtSearchLimit(filterType) && searchIsIdle;
        const utrType = this.props.search.filters?.utrType === 'unverified' ? 'unverified' : 'sanctioned';
        let positionNumber = 0;

        const savedBookmarkEnabled = checkGate(featureGates.SAVED_PLAYER_LIST_ROLLOUT);
        // Fetch only for a Power viewer with the flag on; Free viewers see a greyed bookmark with no probe.
        const savedBookmarkFetchEnabled = savedBookmarkEnabled && !!isPowerUser;
        const playerBookmarkIds = savedBookmarkFetchEnabled
            ? playersWithPrismicContent.filter(hit => hit && !hit.isSponsored && hit.source).map(hit => hit.source.id)
            : [];
        const buildSavedBookmark = (savedStatus, source) => (savedBookmarkEnabled ? {
            enabled: true,
            playerId: source.id,
            playerName: [source.firstName, source.lastName].filter(Boolean).join(' ') || undefined,
            ...savedStatus.getRowStatus(source.id),
            onSaveSuccess: savedStatus.handleSaveSuccess,
            onRemoveSuccess: savedStatus.handleRemoveSuccess,
        } : undefined);

        const rectangleAdIndex = 3;
        const leaderboardAdIndex = 6;
        const shouldShowTwoRectangleAds = isMobileWidth || isTabletWidth;

        return (
            <div className={`container ${styles.search} mb56`}>
                <div className={styles.searchFilters}>
                    <div className={styles.afterLoading}>
                        <div ref={ref => this.filterBox = ref}>
                            {shouldShowSportTypeFilter && (
                                <SportTypeFilter
                                    {...commonFilterProps}
                                    filters={filters}
                                    filterModal={this.state.filterModal}
                                    handleFilterSubmit={this.handleFilterSubmit}
                                    handleFilterUpdate={this.handleFilterUpdate}
                                    applyLocationFilter={this.applyLocationFilter}
                                    closeModals={this.closeModals}
                                    data-testid="search.sport-type-filter"
                                />
                            )}
                            {(!locationFilterNotAllowedEvents.includes(filterType)) && (
                                <LocationFilter
                                    {...commonFilterProps}
                                    filters={filters}
                                    filterModal={this.state.filterModal}
                                    geocoded={search.geocoded}
                                    handleFilterSubmit={this.handleFilterSubmit}
                                    applyLocationFilter={this.applyLocationFilter}
                                    handleLocationChange={this.handleLocationChange}
                                    handleLocationSelect={this.handleLocationSelect}
                                    handleCurrentLocationClick={this.handleCurrentLocationClick}
                                    handleDistanceChange={this.handleDistanceChange}
                                    data-testid="search.location-filter"
                                />
                            )}
                            {filterType && (
                                <>
                                    {filterType === 'players' && (
                                        <PlayerFilters
                                            {...commonFilterProps}
                                            showLearnMoreUtrCollegePopup={this.showLearnMoreUtrCollegePopup}
                                        />
                                    )}
                                    {filterType === 'clubs' && (
                                        <ClubFilters {...commonFilterProps} />
                                    )}
                                    {filterType === 'colleges' && (
                                        <CollegeFilters {...commonFilterProps} />
                                    )}
                                    {filterType === 'highSchools' && (
                                        <HighSchoolFilters {...commonFilterProps} />
                                    )}
                                    {filterType === 'flexLeagues' && (
                                        <FlexLeagueFilters {...commonFilterProps} />
                                    )}
                                    {filterType === 'teamLeagues' && (
                                        <LeagueFilters {...commonFilterProps} />
                                    )}
                                    {filterType === 'proTennisTour' && (
                                        <LeagueFilters {...commonFilterProps} />
                                    )}
                                    {filterType === 'paidHits' && (
                                        <PaidHitsFilters {...commonFilterProps} />
                                    )}
                                    {filterType === 'paidHitClubs' && (
                                        <PaidHitClubFilters {...commonFilterProps} />
                                    )}
                                    {filterType === 'juniorCircuits' && (
                                        <JuniorCircuitFilters
                                            {...commonFilterProps}
                                            ageDisplay={eventsAgeDisplay}
                                            regionSearch={filters.regionSearch}
                                        />
                                    )}
                                    {filterType === 'collegeCircuits' && (
                                        <CollegeCircuitFilters {...commonFilterProps} />
                                    )}
                                    {filterType === 'juniorRegionals' && (
                                        <JuniorRegionalFilters {...commonFilterProps} />
                                    )}
                                </>
                            )}
                            {(!user && !hideFilters.moreFilters && (filterType === playersLabel || filterType === eventsLabel || filterType === collegesLabel)) && (
                                <button
                                    type="button"
                                    className={`btn text-capitalize ${styles.searchFilterBtn}`}
                                    data-testid="search.more-filters-btn"
                                    onClick={() => {
                                        this.props.handleShowLoginPopUp('morefilters');
                                    }}
                                >
                                    More Filters
                                </button>
                            )}
                            {filtersAreActive && (
                                <u style={{ whiteSpace: 'nowrap', marginLeft: 5, fontSize: 12 }} className="clickable text-teal text-small" onClick={() => this.clearFilters(filterType === 'proTennisTour' ? 'proTennis' : 'everythingButType', true)} data-testid="search.reset-filters-link">reset filters</u>
                            )}
                        </div>
                    </div>
                    {(this.state.showLearnMoreUtrCollegePopup) && (
                        <LearnMoreUtrCollegePopUp
                            data-testid="modal.search.learn-more-college"
                            onCloseClick={() => {
                                this.setState({
                                    showLearnMoreUtrCollegePopup: false,
                                    clubToUpgrade: null,
                                });
                            }}
                            handleUpgradeClick={(clubToUpgrade) => {
                                this.setState({
                                    showLearnMoreUtrCollegePopup: false,
                                    showProClubPopup: true,
                                    clubToUpgrade,
                                });
                            }}
                            clubOptionsToUpgrade={this.getFreeCollegeClubIdOptionsUpgrade()}
                        />
                    )}

                    {(this.state.showProClubPopup && this.state.clubToUpgrade) && (
                        <UpgradeToProClubPopUp
                            data-testid="modal.search.upgrade-pro-club"
                            skipIntro={true}
                            onCloseClick={() => {
                                this.setState({
                                    showProClubPopup: false,
                                    clubToUpgrade: null,
                                });
                            }}
                            onSuccess={this.handleProClubSuccess}
                            clubId={this.state.clubToUpgrade.id}
                            clubTierType={{ name: this.state.clubToUpgrade.tierTypeName }}
                            clubName={this.state.clubToUpgrade.name}
                        />
                    )}
                </div>
                {searchHasNotStarted && (
                    <div className={styles.emptypage} data-testid="search.empty-page.no-location">
                        {(filters.lat && filters.lng) || locationFilterNotAllowedEvents.includes(filterType) ? 'Please use search above' : 'Please select your location'}
                    </div>
                )}
                {(this.props.search.isLoading || this.props.search.isLoadingType) && (
                    <div className={styles.emptypage} data-testid="search.loading-indicator">
                        <i className="fas fa-circle-notch fa-spin" />&nbsp;Loading...
                    </div>
                )}
                {searchIsIdle && (players?.total === 0 && clubs?.total === 0 && events?.total === 0 && colleges?.total === 0 && highSchools?.total === 0) && !filterType && (
                    <div className={styles.emptypage} data-testid="search.empty-page.no-results">
                        No results based on your search criteria. Please try again.
                    </div>
                )}
                {(!filterType || filterType == 'players') && players?.total > 0 && !isNotLoading && (
                    <div>
                        <PlayersHeaderColumns
                            filterType={filterType}
                            players={players}
                            sortResults={this.sortResults}
                            utrType={utrType}
                            userLoggedIn={!!user}
                            sportTypes={this.props.search.filters.sportTypes}
                            isItGlobalSearch={true}
                        />
                        <PlayerSearchSavedStatusProvider playerIds={playerBookmarkIds} enabled={savedBookmarkFetchEnabled}>
                            {(savedStatus) => {
                                // The provider re-renders on its own hydration state changes without the
                                // parent, so reset the rank counter each invocation rather than accumulate it.
                                positionNumber = 0;
                                return isPowerUser ? playersWithPrismicContent.map((player, index) => {
                                    if (!player.isSponsored) {
                                        positionNumber += 1;
                                    } else {
                                        return (
                                            <EventCardSponsored
                                                key={`p-ad-${index}`}
                                                featuredEvent={player}
                                                data-testid={`search.players.sponsored-item-${index}`}
                                            />
                                        );
                                    }

                                    return (
                                        <div key={`p-${index}`} className={styles.resultContainer}>
                                            <div className={styles.numberContainer}>
                                                <p data-testid={`search.players.item-${player.source.id}.rank`}>{positionNumber}</p>
                                            </div>
                                            <div className={styles.cardContainer}>
                                                <PlayerCard
                                                    player={player.source}
                                                    showClubCollegeDetails={true}
                                                    utrType={utrType}
                                                    showRatingNotLoggedIn={player.source.isPro}
                                                    showDecimals={player.source.isPro}
                                                    displayCollegeRecruitingValues={displayCollegeRecruitingValues}
                                                    sendMessage={(playerToMessage) => {
                                                        sendMessage(playerToMessage, displayCollegeRecruitingValues);
                                                    }}
                                                    showAdditionalInformation={true}
                                                    filters={filters}
                                                    filterType={filterType}
                                                    players={players}
                                                    sortResults={this.sortResults}
                                                    userLoggedIn={!!user}
                                                    sportTypes={this.props.search.filters.sportTypes}
                                                    isItGlobalSearch={true}
                                                    savedBookmark={buildSavedBookmark(savedStatus, player.source)}
                                                    data-testid={`search.players.item-${player.source.id}`}
                                                />
                                            </div>
                                        </div>
                                    );
                                }) : (
                                    players.hits.map((player, index) => {
                                        const shouldInsertRectanlgeAd = showAds && playerSearchConfig?.showRectangle && index === rectangleAdIndex;
                                        const shouldInsertWideLeaderboardAd = showAds && playerSearchConfig?.showWideLeaderboard && index === leaderboardAdIndex;
                                        positionNumber += 1;

                                        return (
                                            <React.Fragment key={`player-fragment-${player.source.id}`}>
                                                <SearchResultAds
                                                    shouldShowTwoRectangleAds={shouldShowTwoRectangleAds}
                                                    shouldInsertRectangleAd={shouldInsertRectanlgeAd}
                                                    shouldInsertWideLeaderboardAd={shouldInsertWideLeaderboardAd}
                                                />
                                                <div className={styles.resultContainer}>
                                                    <div className={styles.numberContainer}>
                                                        <p data-testid={`search.players.item-${player.source.id}.rank`}>{positionNumber}</p>
                                                    </div>
                                                    <div className={styles.cardContainer}>
                                                        <PlayerCard
                                                            filterType={filterType}
                                                            players={players}
                                                            sortResults={this.sortResults}
                                                            userLoggedIn={!!user}
                                                            sportTypes={this.props.search.filters.sportTypes}
                                                            player={player.source}
                                                            showClubCollegeDetails={true}
                                                            utrType={utrType}
                                                            showRatingNotLoggedIn={player.source.isPro}
                                                            showDecimals={player.source.isPro}
                                                            displayCollegeRecruitingValues={displayCollegeRecruitingValues}
                                                            sendMessage={(playerToMessage) => {
                                                                sendMessage(playerToMessage, displayCollegeRecruitingValues);
                                                            }}
                                                            showAdditionalInformation={true}
                                                            filters={filters}
                                                            savedBookmark={buildSavedBookmark(savedStatus, player.source)}
                                                            data-testid={`search.players.item-${player.source.id}`}
                                                        />
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        );
                                    })
                                );
                            }}
                        </PlayerSearchSavedStatusProvider>
                        {!filterType && (
                            <div className="mt24 ml24">
                                <u className="clickable text-teal" onClick={() => this.handleSeeAllClick('players')} data-testid="search.players.see-all-link">See all</u>
                            </div>
                        )}
                        {filterType == 'players' && !isAtSearchLimit(filterType) && (
                            <button
                                type="button"
                                className="btn btn-default btn-lg text-uppercase mt16 mb16"
                                onClick={() => this.props.loadMore('players')}
                                disabled={isLoadingType}
                                data-testid="search.players.load-more-btn"
                            >
                                {isLoadingType ? <span data-testid="search.players.load-more-btn.loading"><i className="fas fa-circle-notch fa-spin" /> Loading...</span> : <span data-testid="search.players.load-more-btn.label">Load More</span>}
                            </button>
                        )}
                    </div>
                )}
                {filterType === 'players' && !players.total && searchIsIdle && (
                    <p className="mt48 text-center" data-testid="search.players.no-results">There are no players that meet this criteria in this location.</p>
                )}
                {(!filterType || filterType == 'clubs') && clubs && clubs.total > 0 && !isNotLoading && (
                    <div>
                        <ClubsHeaderColumns
                            filterType={filterType}
                            clubs={clubs}
                            sortResults={this.sortResults}
                        />
                        {isPowerUser ? (
                            clubsWithPrismicContent.map((club, i) => {
                                if (club.isSponsored) {
                                    return (
                                        <EventCardSponsored
                                            key={`c-ad-${i}`}
                                            featuredEvent={club}
                                            data-testid={`search.clubs.sponsored-item-${i}`}
                                        />
                                    );
                                }
                                return (
                                    <ClubCard
                                        key={`c-${club.source.id}`}
                                        club={club.source}
                                        data-testid={`search.clubs.item-${club.source.id}`}
                                    />
                                );
                            })
                        ) : (
                            clubs.hits.map((club, index) => {
                                const shouldInsertRectangleAd = showAds && clubSearchConfig?.showRectangle && index === rectangleAdIndex;
                                const shouldInsertWideLeaderboardAd = showAds && clubSearchConfig?.showWideLeaderboard && index === leaderboardAdIndex;

                                return (
                                    <React.Fragment key={`c-${club.source.id}`}>
                                        <SearchResultAds
                                            shouldShowTwoRectangleAds={shouldShowTwoRectangleAds}
                                            shouldInsertRectangleAd={shouldInsertRectangleAd}
                                            shouldInsertWideLeaderboardAd={shouldInsertWideLeaderboardAd}
                                        />
                                        <ClubCard
                                            key={`c-${club.source.id}`}
                                            club={club.source}
                                            data-testid={`search.clubs.item-${club.source.id}`}
                                        />
                                    </React.Fragment>
                                );
                            })
                        )}
                        {!filterType && (
                            <div className="mt24 ml24">
                                <u className="clickable text-teal" onClick={() => this.handleSeeAllClick('clubs')} data-testid="search.clubs.see-all-link">See all</u>
                            </div>
                        )}
                        {filterType == 'clubs' && !isAtSearchLimit(filterType) && (
                            <button
                                type="button"
                                className="btn btn-default btn-lg text-uppercase mt16 mb16"
                                onClick={() => this.props.loadMore('clubs')}
                                disabled={isLoadingType}
                                data-testid="search.clubs.load-more-btn"
                            >
                                {isLoadingType ? <span data-testid="search.clubs.load-more-btn.loading"><i className="fas fa-circle-notch fa-spin" /> Loading...</span> : <span data-testid="search.clubs.load-more-btn.label">Load More</span>}
                            </button>
                        )}
                    </div>
                )}
                {filterType === 'clubs' && !clubs.total && searchIsIdle && (
                    <p className="mt48 text-center" data-testid="search.clubs.no-results">There are no clubs that meet this criteria in this location.</p>
                )}
                {isCampsWithResults(filterType, camps) && (
                    <div>
                        <div className={`${styles.searchHeaders}`}>
                            <div className="flex-grow" data-testid="search.camps.section-heading">
                                Camps
                            </div>
                        </div>
                        <Events
                            allEvents={camps}
                            allEventsWithPrismicContent={campsWithPrismicContent}
                            auth={this.props.auth}
                            eventResultsOptions={eventResultsOptions}
                            eventSearchConfig={eventSearchConfig}
                            shouldShowTwoRectangleAds={shouldShowTwoRectangleAds}
                            isPowerUser={isPowerUser}
                            showAds={showAds}
                            testidPrefix="search.camps"
                        />
                        {!filterType && (
                            <div className="mt24 ml24">
                                <u className="clickable text-teal" onClick={() => this.handleSeeAllClick('camps')} data-testid="search.camps.see-all-link">See all</u>
                            </div>
                        )}
                        {filterType == 'camps' && !isAtSearchLimit(filterType) && (
                            <button
                                type="button"
                                className="btn btn-default btn-lg text-uppercase mt16 mb16"
                                onClick={() => this.props.loadMore('camps')}
                                disabled={isLoadingType}
                                data-testid="search.camps.load-more-btn"
                            >
                                {isLoadingType ? <span data-testid="search.camps.load-more-btn.loading"><i className="fas fa-circle-notch fa-spin" /> Loading...</span> : <span data-testid="search.camps.load-more-btn.label">Load More</span>}
                            </button>
                        )}
                    </div>
                )}
                {isCampsWithNoResults(filterType, camps) && (
                    <p className="mt48 text-center" data-testid="search.camps.no-results">There are no camps that meet this criteria in this location.</p>
                )}
                {(!filterType || filterType == 'events') && events && events.total > 0 && !isNotLoading && (
                    <div>
                        <div className={`${styles.searchHeaders}`}>
                            <div className="flex-grow" data-testid="search.events.section-heading">
                                Events
                            </div>
                        </div>
                        <Events
                            allEvents={events}
                            allEventsWithPrismicContent={eventsWithPrismicContent}
                            auth={this.props.auth}
                            eventResultsOptions={eventResultsOptions}
                            eventSearchConfig={eventSearchConfig}
                            shouldShowTwoRectangleAds={shouldShowTwoRectangleAds}
                            isPowerUser={isPowerUser}
                            showAds={showAds}
                            testidPrefix="search.events"
                        />
                        {!filterType && (
                            <div className="mt24 ml24">
                                <u className="clickable text-teal" onClick={() => this.handleSeeAllClick('events')} data-testid="search.events.see-all-link">See all</u>
                            </div>
                        )}
                        {filterType == 'events' && !isAtSearchLimit(filterType) && (
                            <button
                                type="button"
                                className="btn btn-default btn-lg text-uppercase mt16 mb16"
                                onClick={() => this.props.loadMore('events')}
                                disabled={isLoadingType}
                                data-testid="search.events.load-more-btn"
                            >
                                {isLoadingType ? <span data-testid="search.events.load-more-btn.loading"><i className="fas fa-circle-notch fa-spin" /> Loading...</span> : <span data-testid="search.events.load-more-btn.label">Load More</span>}
                            </button>
                        )}
                    </div>
                )}
                {filterType === 'events' && !events.total && searchIsIdle && (
                    <p className="mt48 text-center" data-testid="search.events.no-results">There are no events that meet this criteria in this location.</p>
                )}
                {(!filterType || filterType == 'flexLeagues') && flexLeagues && flexLeagues.total > 0 && !isNotLoading && (
                    <div>
                        <div className={`${styles.searchHeaders}`}>
                            <div className="flex-grow" data-testid="search.flex-leagues.section-heading">
                                UTR Sports Flex Leagues
                            </div>
                        </div>
                        <Events
                            allEvents={flexLeagues}
                            allEventsWithPrismicContent={flexLeaguesWithPrismicContent}
                            auth={this.props.auth}
                            eventResultsOptions={eventResultsOptions}
                            eventSearchConfig={eventSearchConfig}
                            shouldShowTwoRectangleAds={shouldShowTwoRectangleAds}
                            isPowerUser={isPowerUser}
                            showAds={showAds}
                            testidPrefix="search.flex-leagues"
                        />
                        {!filterType && (
                            <div className="mt24 ml24">
                                <u className="clickable text-teal" onClick={() => this.handleSeeAllClick('flexLeagues')} data-testid="search.flex-leagues.see-all-link">See all</u>
                            </div>
                        )}
                        {filterType == 'flexLeagues' && !isAtSearchLimit(filterType) && (
                            <button
                                type="button"
                                className="btn btn-default btn-lg text-uppercase mt16 mb16"
                                onClick={() => this.props.loadMore('flexLeagues')}
                                disabled={isLoadingType}
                                data-testid="search.flex-leagues.load-more-btn"
                            >
                                {isLoadingType ? <span data-testid="search.flex-leagues.load-more-btn.loading"><i className="fas fa-circle-notch fa-spin" /> Loading...</span> : <span data-testid="search.flex-leagues.load-more-btn.label">Load More</span>}
                            </button>
                        )}
                    </div>
                )}
                {filterType === 'flexLeagues' && !flexLeagues.total && searchIsIdle && (
                    <p className="mt48 text-center" data-testid="search.flex-leagues.no-results">There are no events that meet this criteria.</p>
                )}
                {(!filterType || filterType == 'teamLeagues') && teamLeagues && teamLeagues.total > 0 && !isNotLoading && (
                    <div>
                        <div className={`${styles.searchHeaders}`}>
                            <div className="flex-grow" data-testid="search.team-leagues.section-heading">
                                UTR Sports Team Tennis
                            </div>
                        </div>
                        <Events
                            allEvents={teamLeagues}
                            allEventsWithPrismicContent={teamLeaguesWithPrismicContent}
                            auth={this.props.auth}
                            eventResultsOptions={eventResultsOptions}
                            eventSearchConfig={eventSearchConfig}
                            shouldShowTwoRectangleAds={shouldShowTwoRectangleAds}
                            isPowerUser={isPowerUser}
                            showAds={showAds}
                            testidPrefix="search.team-leagues"
                        />
                        {!filterType && (
                            <div className="mt24 ml24">
                                <u className="clickable text-teal" onClick={() => this.handleSeeAllClick('teamLeagues')} data-testid="search.team-leagues.see-all-link">See all</u>
                            </div>
                        )}
                        {filterType == 'teamLeagues' && !isAtSearchLimit(filterType) && (
                            <button
                                type="button"
                                className="btn btn-default btn-lg text-uppercase mt16 mb16"
                                onClick={() => this.props.loadMore('teamLeagues')}
                                disabled={isLoadingType}
                                data-testid="search.team-leagues.load-more-btn"
                            >
                                {isLoadingType ? <span data-testid="search.team-leagues.load-more-btn.loading"><i className="fas fa-circle-notch fa-spin" /> Loading...</span> : <span data-testid="search.team-leagues.load-more-btn.label">Load More</span>}
                            </button>
                        )}
                    </div>
                )}
                {filterType === 'teamLeagues' && !teamLeagues.total && searchIsIdle && (
                    <p className="mt48 text-center" data-testid="search.team-leagues.no-results">There are no events that meet this criteria.</p>
                )}
                {(!filterType || filterType == 'proTennisTour') && proTennisTour && proTennisTour.total > 0 && !isNotLoading && (
                    <div>
                        <div className={`${styles.searchHeaders}`}>
                            <div className="flex-grow" data-testid="search.pro-tennis-tour.section-heading">
                                Pro Tennis Tour
                            </div>
                        </div>
                        <Events
                            allEvents={proTennisTour}
                            allEventsWithPrismicContent={proTennisTourWithPrismicContent}
                            auth={this.props.auth}
                            eventResultsOptions={eventResultsOptions}
                            eventSearchConfig={eventSearchConfig}
                            shouldShowTwoRectangleAds={shouldShowTwoRectangleAds}
                            isPowerUser={isPowerUser}
                            showAds={showAds}
                            testidPrefix="search.pro-tennis-tour"
                        />
                        {!filterType && (
                            <div className="mt24 ml24">
                                <u className="clickable text-teal" onClick={() => this.handleSeeAllClick('proTennisTour')} data-testid="search.pro-tennis-tour.see-all-link">See all</u>
                            </div>
                        )}
                        {filterType == 'proTennisTour' && !isAtSearchLimit(filterType) && (
                            <button
                                type="button"
                                className="btn btn-default btn-lg text-uppercase mt16 mb16"
                                onClick={() => this.props.loadMore('proTennisTour')}
                                disabled={isLoadingType}
                                data-testid="search.pro-tennis-tour.load-more-btn"
                            >
                                {isLoadingType ? <span data-testid="search.pro-tennis-tour.load-more-btn.loading"><i className="fas fa-circle-notch fa-spin" /> Loading...</span> : <span data-testid="search.pro-tennis-tour.load-more-btn.label">Load More</span>}
                            </button>
                        )}
                    </div>
                )}
                {filterType === 'proTennisTour' && !proTennisTour.total && searchIsIdle && (
                    <p className="mt48 text-center" data-testid="search.pro-tennis-tour.no-results">There are no events that meet this criteria.</p>
                )}
                {(!filterType || filterType == 'paidHits') && paidHits && paidHits.total > 0 && !isNotLoading && (
                    <div>
                        <div className={`${styles.searchHeaders}`}>
                            <div className="flex-grow" data-testid="search.paid-hits.section-heading">
                                Paid Hits
                            </div>
                        </div>
                        <Events
                            allEvents={paidHits}
                            allEventsWithPrismicContent={paidHitsWithPrismicContent}
                            auth={this.props.auth}
                            eventResultsOptions={eventResultsOptions}
                            eventSearchConfig={eventSearchConfig}
                            shouldShowTwoRectangleAds={shouldShowTwoRectangleAds}
                            isPowerUser={isPowerUser}
                            showAds={showAds}
                            testidPrefix="search.paid-hits"
                        />
                        {!filterType && (
                            <div className="mt24 ml24">
                                <u className="clickable text-teal" onClick={() => this.handleSeeAllClick('paidHits')} data-testid="search.paid-hits.see-all-link">See all</u>
                            </div>
                        )}
                        {filterType == 'paidHits' && !isAtSearchLimit(filterType) && (
                            <button
                                type="button"
                                className="btn btn-default btn-lg text-uppercase mt16 mb16"
                                onClick={() => this.props.loadMore('paidHits')}
                                disabled={isLoadingType}
                                data-testid="search.paid-hits.load-more-btn"
                            >
                                {isLoadingType ? <span data-testid="search.paid-hits.load-more-btn.loading"><i className="fas fa-circle-notch fa-spin" /> Loading...</span> : <span data-testid="search.paid-hits.load-more-btn.label">Load More</span>}
                            </button>
                        )}
                    </div>
                )}
                {filterType === 'paidHits' && !paidHits.total && searchIsIdle && (
                    <p className="mt48 text-center" data-testid="search.paid-hits.no-results">There are no events that meet this criteria.</p>
                )}
                {(!filterType || (filterType == 'juniorCircuits' && filters?.regionSearch)) && juniorCircuits?.total > 0 && !isNotLoading && (
                    <div>
                        <JuniorCircuitsHeaderColumns
                            filterType={filterType}
                            juniorCircuits={juniorCircuits}
                            sortResults={this.sortResults}
                            utrType={utrType}
                            userLoggedIn={!!user}
                        />
                        <Events
                            allEvents={juniorCircuits}
                            allEventsWithPrismicContent={juniorCircuitsWithPrismicContent}
                            auth={this.props.auth}
                            eventResultsOptions={eventResultsOptions}
                            isJuniorCircuitEvent={true}
                            isPowerUser={isPowerUser}
                            eventSearchConfig={eventSearchConfig}
                            shouldShowTwoRectangleAds={shouldShowTwoRectangleAds}
                            showAds={showAds}
                            testidPrefix="search.junior-circuits"
                        />
                        {!filterType && (
                            <div className="mt24 ml24">
                                <u className="clickable text-teal" onClick={() => this.handleSeeAllClick('juniorCircuits')} data-testid="search.junior-circuits.region.see-all-link">See all</u>
                            </div>
                        )}
                        {filterType == juniorCircuitsLabel && !isAtSearchLimit(filterType) && (
                            <button
                                type="button"
                                className="btn btn-default btn-lg text-uppercase mt16 mb16"
                                onClick={() => this.props.loadMore(juniorCircuitsLabel)}
                                disabled={isLoadingType}
                                data-testid="search.junior-circuits.region.load-more-btn"
                            >
                                {isLoadingType ? <span data-testid="search.junior-circuits.region.load-more-btn.loading"><i className="fas fa-circle-notch fa-spin" /> Loading...</span> : <span data-testid="search.junior-circuits.region.load-more-btn.label">Load More</span>}
                            </button>
                        )}
                    </div>
                )}
                {(!filterType || (filterType == 'juniorCircuits' && !filters?.regionSearch)) && juniorCircuits?.total > 0 && !isNotLoading && (
                    <div>
                        <div className={`${styles.searchHeaders}`}>
                            <div className="flex-grow" data-testid="search.junior-circuits.section-heading">
                                Junior Circuits
                            </div>
                        </div>
                        <Events
                            allEvents={juniorCircuits}
                            allEventsWithPrismicContent={juniorCircuitsWithPrismicContent}
                            auth={this.props.auth}
                            eventResultsOptions={eventResultsOptions}
                            eventSearchConfig={eventSearchConfig}
                            shouldShowTwoRectangleAds={shouldShowTwoRectangleAds}
                            isPowerUser={isPowerUser}
                            showAds={showAds}
                            testidPrefix="search.junior-circuits"
                        />
                        {!filterType && (
                            <div className="mt24 ml24">
                                <u className="clickable text-teal" onClick={() => this.handleSeeAllClick('juniorCircuits')} data-testid="search.junior-circuits.see-all-link">See all</u>
                            </div>
                        )}
                        {filterType == 'juniorCircuits' && !isAtSearchLimit(filterType) && (
                            <button
                                type="button"
                                className="btn btn-default btn-lg text-uppercase mt16 mb16"
                                onClick={() => this.props.loadMore('juniorCircuits')}
                                disabled={isLoadingType}
                                data-testid="search.junior-circuits.load-more-btn"
                            >
                                {isLoadingType ? <span data-testid="search.junior-circuits.load-more-btn.loading"><i className="fas fa-circle-notch fa-spin" /> Loading...</span> : <span data-testid="search.junior-circuits.load-more-btn.label">Load More</span>}
                            </button>
                        )}
                    </div>
                )}
                {filterType === 'juniorCircuits' && !juniorCircuits.total && searchIsIdle && (
                    <p className="mt48 text-center" data-testid="search.junior-circuits.no-results">There are no events that meet this criteria.</p>
                )}
                {(isCollegeCircuits &&
                    hasCollegeCircuits &&
                    !(isSearchLoading && !isSearchLoadingType)) && (
                        <div>
                            <div className={`${styles.searchHeaders}`}>
                                <div className="flex-grow" data-testid="search.college-circuits.section-heading">
                                    College Circuits
                                </div>
                            </div>
                            <Events
                                allEvents={collegeCircuits}
                                allEventsWithPrismicContent={collegeCircuitsWithPrismicContent}
                                auth={this.props.auth}
                                eventResultsOptions={eventResultsOptions}
                                eventSearchConfig={eventSearchConfig}
                                shouldShowTwoRectangleAds={shouldShowTwoRectangleAds}
                                isPowerUser={isPowerUser}
                                showAds={showAds}
                                testidPrefix="search.college-circuits"
                            />
                            {!filterType && (
                                <div className="mt24 ml24">
                                    <u className="clickable text-teal" onClick={() => this.handleSeeAllClick('collegeCircuits')} data-testid="search.college-circuits.see-all-link">See all</u>
                                </div>
                            )}
                            {filterType === collegeCircuitsLabel && !isAtSearchLimit(filterType) && (
                                <button
                                    type="button"
                                    className="btn btn-default btn-lg text-uppercase mt16 mb16"
                                    onClick={() => this.props.loadMore('collegeCircuits')}
                                    disabled={isLoadingType}
                                    data-testid="search.college-circuits.load-more-btn"
                                >
                                    {isLoadingType ? <span data-testid="search.college-circuits.load-more-btn.loading"><i className="fas fa-circle-notch fa-spin" /> Loading...</span> : <span data-testid="search.college-circuits.load-more-btn.label">Load More</span>}
                                </button>
                            )}
                        </div>
                    )}
                {filterType === collegeCircuitsLabel && !collegeCircuits.total && searchIsIdle && (
                    <p className="mt48 text-center" data-testid="search.college-circuits.no-results">There are no events that meet this criteria.</p>
                )}
                {(isJuniorRegionals && hasJuniorRegionals && !(isSearchLoading && !isSearchLoadingType)) && (
                    <div>
                        <div className={`${styles.searchHeaders}`}>
                            <div className="flex-grow" data-testid="search.junior-regionals.section-heading">
                                Junior Regionals
                            </div>
                        </div>
                        <Events
                            allEvents={juniorRegionals}
                            allEventsWithPrismicContent={juniorRegionalsWithPrismicContent}
                            auth={this.props.auth}
                            eventResultsOptions={eventResultsOptions}
                            eventSearchConfig={eventSearchConfig}
                            shouldShowTwoRectangleAds={shouldShowTwoRectangleAds}
                            isPowerUser={isPowerUser}
                            showAds={showAds}
                            testidPrefix="search.junior-regionals"
                        />
                        {!filterType && (
                            <div className="mt24 ml24">
                                <u className="clickable text-teal" onClick={() => this.handleSeeAllClick('juniorRegionals')} data-testid="search.junior-regionals.see-all-link">See all</u>
                            </div>
                        )}
                        {filterType === juniorRegionalsLabel && !isAtSearchLimit(filterType) && (
                            <button
                                type="button"
                                className="btn btn-default btn-lg text-uppercase mt16 mb16"
                                onClick={() => this.props.loadMore('juniorRegionals')}
                                disabled={isLoadingType}
                                data-testid="search.junior-regionals.load-more-btn"
                            >
                                {isLoadingType ? <span data-testid="search.junior-regionals.load-more-btn.loading"><i className="fas fa-circle-notch fa-spin" /> Loading...</span> : <span data-testid="search.junior-regionals.load-more-btn.label">Load More</span>}
                            </button>
                        )}
                    </div>
                )}
                {filterType === juniorRegionalsLabel && !juniorRegionals.total && searchIsIdle && (
                    <p className="mt48 text-center" data-testid="search.junior-regionals.no-results">There are no events that meet this criteria.</p>
                )}
                {(!filterType || filterType == 'colleges') && colleges && colleges.total > 0 && !isNotLoading && (
                    <div>
                        <CollegeHeaderColumns
                            filterType={filterType}
                            colleges={colleges}
                            sortResults={this.sortResults}
                            isPowerUser={isPowerUser}
                            isRostersRolloutEnabled={isRostersRolloutEnabled}
                        />
                        {collegesWithPrismicContent.map((schoolClub, i) => {
                                if (schoolClub.isSponsored) {
                                    return (
                                        <EventCardSponsored
                                            key={`col-ad-${i}`}
                                            featuredEvent={schoolClub}
                                            data-testid={`search.colleges.sponsored-item-${i}`}
                                        />
                                    );
                                }
                                return (
                                    <React.Fragment key={`f-${schoolClub.source.id}`}>
                                        <div key={`s-${schoolClub.source.id}`} className="d-none d-md-block">
                                            <a href={`/colleges/${schoolClub.source.id}`} data-testid={`search.colleges.item-${schoolClub.source.id}.desktop-link`}>
                                                <SchoolCard
                                                    schoolClub={schoolClub.source}
                                                    force={{ collegeDetails: true }}
                                                    isPowerUser={isPowerUser}
                                                    clubSubTypes={clubSubTypes}
                                                    user={user}
                                                    checkGate={checkGate}
                                                    featureGates={featureGates}
                                                    data-testid={`search.colleges.item-${schoolClub.source.id}`}
                                                />
                                            </a>
                                        </div>
                                        <div key={`s-${schoolClub.source.id}-card`} className="d-block d-md-none">
                                            <a href={`/colleges/${schoolClub.source.id}`} data-testid={`search.colleges.item-${schoolClub.source.id}.mobile-link`}>
                                                <CollegeHSClubCard
                                                    club={schoolClub.source}
                                                    checkGate={checkGate}
                                                    featureGates={featureGates}
                                                    isPowerUser={isPowerUser}
                                                    data-testid={`search.colleges.item-${schoolClub.source.id}.mobile-card`}
                                                />
                                            </a>
                                        </div>
                                    </React.Fragment>
                                );
                            })}
                        {!filterType && (
                            <div className="mt24 ml24">
                                <u className="clickable text-teal" onClick={() => this.handleSeeAllClick('colleges')} data-testid="search.colleges.see-all-link">See all</u>
                            </div>
                        )}
                        {filterType == 'colleges' && !isAtSearchLimit(filterType) && (
                            <button
                                type="button"
                                className="btn btn-default btn-lg text-uppercase mt16 mb16"
                                onClick={() => this.props.loadMore('colleges')}
                                disabled={isLoadingType}
                                data-testid="search.colleges.load-more-btn"
                            >
                                {isLoadingType ? <span data-testid="search.colleges.load-more-btn.loading"><i className="fas fa-circle-notch fa-spin" /> Loading...</span> : <span data-testid="search.colleges.load-more-btn.label">Load More</span>}
                            </button>
                        )}
                    </div>
                )}
                {filterType === 'colleges' && !colleges.total && searchIsIdle && (
                    <p className="mt48 text-center" data-testid="search.colleges.no-results">There are no colleges that meet this criteria in this location.</p>
                )}
                {(!filterType || filterType == 'highSchools') && highSchools && highSchools.total > 0 && !isNotLoading && (
                    <div>
                        <HighSchoolHeaderColumns
                            filterType={filterType}
                            highSchools={highSchools}
                            sortResults={this.sortResults}
                            isPowerUser={isPowerUser}
                            isNewRosterModel={isHsNewRosterModel}
                        />
                        {highSchoolsWithPrismicContent.map((schoolClub, i) => {
                                if (schoolClub.isSponsored) {
                                    return (
                                        <EventCardSponsored
                                            key={`hs-ad-${i}`}
                                            featuredEvent={schoolClub}
                                            data-testid={`search.high-schools.sponsored-item-${i}`}
                                        />
                                    );
                                }
                                return (
                                    <React.Fragment key={`f-${schoolClub.source.id}`}>
                                        <div key={`s-${schoolClub.source.id}`} className="d-none d-md-block">
                                            <a href={`/schools/${schoolClub.source.id}`} data-testid={`search.high-schools.item-${schoolClub.source.id}.desktop-link`}>
                                                <SchoolCard
                                                    schoolClub={schoolClub.source}
                                                    force={{ collegeDetails: false }}
                                                    isPowerUser={isPowerUser}
                                                    clubSubTypes={clubSubTypes}
                                                    user={user}
                                                    checkGate={checkGate}
                                                    featureGates={featureGates}
                                                    data-testid={`search.high-schools.item-${schoolClub.source.id}`}
                                                />
                                            </a>
                                        </div>
                                        <div key={`s-${schoolClub.source.id}-card`} className="d-block d-md-none">
                                            <a href={`/schools/${schoolClub.source.id}`} data-testid={`search.high-schools.item-${schoolClub.source.id}.mobile-link`}>
                                                <CollegeHSClubCard
                                                    club={schoolClub.source}
                                                    checkGate={checkGate}
                                                    featureGates={featureGates}
                                                    isPowerUser={isPowerUser}
                                                    data-testid={`search.high-schools.item-${schoolClub.source.id}.mobile-card`}
                                                />
                                            </a>
                                        </div>
                                    </React.Fragment>
                                );
                            })}
                        {!filterType && (
                            <div className="mt24 ml24">
                                <u className="clickable text-teal" onClick={() => this.handleSeeAllClick('highSchools')} data-testid="search.high-schools.see-all-link">See all</u>
                            </div>
                        )}
                        {filterType == 'highSchools' && !isAtSearchLimit(filterType) && (
                            <button
                                type="button"
                                className="btn btn-default btn-lg text-uppercase mt16 mb16"
                                onClick={() => this.props.loadMore('highSchools')}
                                disabled={isLoadingType}
                                data-testid="search.high-schools.load-more-btn"
                            >
                                {isLoadingType ? <span data-testid="search.high-schools.load-more-btn.loading"><i className="fas fa-circle-notch fa-spin" /> Loading...</span> : <span data-testid="search.high-schools.load-more-btn.label">Load More</span>}
                            </button>
                        )}
                    </div>
                )}
                {filterType === 'highSchools' && !highSchools.total && searchIsIdle && (
                    <p className="mt48 text-center" data-testid="search.high-schools.no-results">There are no high schools that meet this criteria in this location.</p>
                )}

                {showAdultTeamClubs && (
                    <div>
                        <AdultTeamClubsHeaderColumns
                            filterType={filterType}
                            adultTeamClubs={adultTeamClubs}
                            sortResults={this.sortResults}
                        />
                        {adultTeamClubsWithPrismicContent.map((adultTeamClub, i) => {
                                if (adultTeamClub.isSponsored) {
                                    return (
                                        <EventCardSponsored
                                            key={`c-ad-${i}`}
                                            featuredEvent={adultTeamClub}
                                            data-testid={`search.adult-team-clubs.sponsored-item-${i}`}
                                        />
                                    );
                                }
                                return (
                                    <TeamClubCard
                                        key={`c-${adultTeamClub.source.id}`}
                                        adultTeamClub={adultTeamClub.source}
                                        data-testid={`search.adult-team-clubs.item-${adultTeamClub.source.id}`}
                                    />
                                );
                            })}
                        {!filterType && (
                            <div className="mt24 ml24">
                                <u className="clickable text-teal" onClick={() => this.handleSeeAllClick('adultTeamClubs')} data-testid="search.adult-team-clubs.see-all-link">See all</u>
                            </div>
                        )}
                        {showLoadMoreAdultTeamClubs && (
                            <button
                                type="button"
                                className="btn btn-default btn-lg text-uppercase mt16 mb16"
                                onClick={() => this.props.loadMore('adultTeamClubs')}
                                disabled={isLoadingType}
                                data-testid="search.adult-team-clubs.load-more-btn"
                            >
                                {isLoadingType ? <span data-testid="search.adult-team-clubs.load-more-btn.loading"><i className="fas fa-circle-notch fa-spin" /> Loading...</span> : <span data-testid="search.adult-team-clubs.load-more-btn.label">Load More</span>}
                            </button>
                        )}
                    </div>
                )}
                {showNoAdultTeamClubsMessage && (
                    <p className="mt48 text-center" data-testid="search.adult-team-clubs.no-results">There are no adult league teams that meet this criteria in this location.</p>
                )}

                {showPaidHitClubs && (
                    <div>
                        <PaidHitClubsHeaderColumns
                            filterType={filterType}
                            paidHitClubs={paidHitClubs}
                            sortResults={this.sortResults}
                        />
                        {paidHitClubsWithPrismicContent.map((paidHitClub, i) => {
                                if (paidHitClub.isSponsored) {
                                    return (
                                        <EventCardSponsored
                                            key={`c-ad-${i}`}
                                            featuredEvent={paidHitClub}
                                            data-testid={`search.paid-hit-clubs.sponsored-item-${i}`}
                                        />
                                    );
                                }
                                return (
                                    <PaidHitClubCard
                                        key={`c-${paidHitClub.source.id}`}
                                        paidHitClub={paidHitClub.source}
                                        coreUITypes={coreUI.types}
                                        data-testid={`search.paid-hit-clubs.item-${paidHitClub.source.id}`}
                                    />
                                );
                            })}
                        {!filterType && (
                            <div className="mt24 ml24">
                                <u className="clickable text-teal" onClick={() => this.handleSeeAllClick('paidHitClubs')} data-testid="search.paid-hit-clubs.see-all-link">See all</u>
                            </div>
                        )}
                        {showLoadMorePaidHitClubs && (
                            <button
                                type="button"
                                className="btn btn-default btn-lg text-uppercase mt16 mb16"
                                onClick={() => this.props.loadMore('paidHitClubs')}
                                disabled={isLoadingType}
                                data-testid="search.paid-hit-clubs.load-more-btn"
                            >
                                {isLoadingType ? <span data-testid="search.paid-hit-clubs.load-more-btn.loading"><i className="fas fa-circle-notch fa-spin" /> Loading...</span> : <span data-testid="search.paid-hit-clubs.load-more-btn.label">Load More</span>}
                            </button>
                        )}
                    </div>
                )}
                {showNoPaidHitClubsMessage && (
                    <p className="mt48 text-center" data-testid="search.paid-hit-clubs.no-results">There are no paid hitters that meet this criteria in this location.</p>
                )}
                {showUpgradeToPowerLink && (
                    <p className="text-center mt32" data-testid="search.upgrade-power-link-wrapper">
                        Want to see more results?&nbsp;
                        <UpgradeToPowerLinkV2
                            className="clickable text-teal"
                            location="Search Results"
                            data-testid="search.upgrade-power-link"
                        />
                    </p>
                )}
                {!user && (filterType === playersLabel || filterType === clubsLabel) && isAtSearchLimit(filterType) && searchIsIdle && (
                    <p className="text-dark mt32" data-testid="search.join-sign-in-wrapper"><u className="clickable text-teal" onClick={() => { this.props.handleShowLoginPopUp('signup'); }} data-testid="search.join-sign-in-link">Join / Sign in</u> to see all ratings, results, and filters</p>
                )}
                {this.state.showSearchPageReportsWelcomePopUp && (
                    <SearchPageReportsWelcomePopUp
                        onCloseClick={() => {
                            this.setState({
                                showSearchPageReportsWelcomePopUp: false,
                            });
                            const queryStringWithoutWelcomeReports = this.props.location.search.replace('&welcome_reports=true', '');
                            this.props.history.push(this.props.location.pathname + queryStringWithoutWelcomeReports);
                        }}
                        onCtaClick={() => {
                            this.setState({
                                showSearchPageReportsWelcomePopUp: false,
                            });
                            const queryStringWithoutWelcomeReports = this.props.location.search.replace('&welcome_reports=true', '');
                            this.props.history.push(this.props.location.pathname + queryStringWithoutWelcomeReports);
                        }}
                    />
                )}
            </div>
        );
    }
}

const SearchResultAds = ({ shouldShowTwoRectangleAds, shouldInsertRectangleAd, shouldInsertWideLeaderboardAd }) => {
    const { RECTANGLE_ONE, RECTANGLE_TWO, RECTANGLE_THREE, WIDE_LEADERBOARD_ONE } = AdTypes;
    return (
        <>
            {shouldInsertRectangleAd && (
                shouldShowTwoRectangleAds ? (
                    <div className={styles.rectangleAdContainer}>
                        <AdWrapper type={RECTANGLE_ONE} data-testid="search.results.ad.rectangle-1" />
                        <div className={styles.lastRectangleAd}>
                            <AdWrapper type={RECTANGLE_TWO} data-testid="search.results.ad.rectangle-2" />
                        </div>
                    </div>
                ) : (
                    <div className={styles.rectangleAdContainer}>
                        <AdWrapper type={RECTANGLE_ONE} data-testid="search.results.ad.rectangle-1" />
                        <AdWrapper type={RECTANGLE_TWO} data-testid="search.results.ad.rectangle-2" />
                        <AdWrapper type={RECTANGLE_THREE} data-testid="search.results.ad.rectangle-3" />
                    </div>
                )
            )}
            {shouldInsertWideLeaderboardAd && (
                <div className={styles.leaderboardAdContainer}>
                    <AdWrapper type={WIDE_LEADERBOARD_ONE} data-testid="search.results.ad.wide-leaderboard" />
                </div>
            )}
        </>
    );
};

const Events = ({ eventResultsOptions, allEvents, auth, allEventsWithPrismicContent, eventSearchConfig, shouldShowTwoRectangleAds, isPowerUser, isJuniorCircuitEvent, showAds, testidPrefix }) => {
    const getCardComponent = (event) => {
        if (isJuniorCircuitEvent) {
            return (
                <JuniorCircuitEventCard
                    key={`e-${event.source.id}`}
                    event={event.source}
                    auth={auth}
                    tourTag={eventResultsOptions?.tourTag}
                    data-testid={testidPrefix && `${testidPrefix}.item-${event.source.id}`}
                />
            );
        }
        return (
            <EventCard
                key={`e-${event.source.id}`}
                event={event.source}
                auth={auth}
                tourTag={eventResultsOptions?.tourTag}
                isSearchResultsPage={true}
                data-testid={testidPrefix && `${testidPrefix}.item-${event.source.id}`}
            />
        );
    };

    return (
        isPowerUser ? (
            allEventsWithPrismicContent.map((event, i) => {
                if (event.isSponsored) {
                    return (
                        <EventCardSponsored
                            key={`e-ad-${i}`}
                            featuredEvent={event}
                            data-testid={testidPrefix && `${testidPrefix}.sponsored-item-${i}`}
                        />
                    );
                }
                return getCardComponent(event);
            })
        ) : (
            allEvents.hits.map((event, index) => {
                const rectangleAdIndex = 3;
                const leaderboardAdIndex = 6;
                const shouldInsertRectangleAd = showAds && eventSearchConfig?.showRectangle && index === rectangleAdIndex;
                const shouldInsertWideLeaderboardAd = showAds && eventSearchConfig?.showWideLeaderboard && index === leaderboardAdIndex;
                return (
                    <React.Fragment key={`e-${event.source.id}`}>
                        <SearchResultAds
                            shouldShowTwoRectangleAds={shouldShowTwoRectangleAds}
                            shouldInsertRectangleAd={shouldInsertRectangleAd}
                            shouldInsertWideLeaderboardAd={shouldInsertWideLeaderboardAd}
                        />
                        {getCardComponent(event)}
                    </React.Fragment>
                );
            })
        )
    );
};
Events.propTypes = {
    eventResultsOptions: PropTypes.shape,
    allEvents: PropTypes.arrayOf(PropTypes.shape),
    auth: PropTypes.shape,
    allEventsWithPrismicContent: PropTypes.shape,
    eventSearchConfig: PropTypes.shape,
    shouldShowTwoRectangleAds: PropTypes.bool,
    isPowerUser: PropTypes.bool,
    isJuniorCircuitEvent: PropTypes.bool,
    showAds: PropTypes.bool,
};

SearchResultAds.propTypes = {
    shouldShowTwoRectangleAds: PropTypes.bool.isRequired,
    shouldInsertRectangleAd: PropTypes.bool.isRequired,
    shouldInsertWideLeaderboardAd: PropTypes.bool.isRequired,
};

SearchResults.propTypes = {
    updateFiltersApplied: PropTypes.func,
    applySearchFilters: PropTypes.func,
    coreUI: PropTypes.shape({
        types: PropTypes.shape({
            clubSubTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
            search: PropTypes.shape({}).isRequired,
            tms: PropTypes.shape({
                sportTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
            }),
        }),
    }).isRequired,
    eventResultsOptions: PropTypes.instanceOf(Object),
    sendMessage: PropTypes.func.isRequired,
    searchPageType: PropTypes.string,
    isPickleballSportFilterEnabled: PropTypes.bool,
    changeFilterInputs: PropTypes.func,
    auth: PropTypes.instanceOf(Object).isRequired,
    checkGate: PropTypes.func.isRequired,
    featureGates: PropTypes.shape({
        DINGLES: PropTypes.string,
    }).isRequired,
    search: PropTypes.shape({
        filterInputs: PropTypes.shape({
            startDate: PropTypes.instanceOf(moment),
            endDate: PropTypes.instanceOf(moment),
        }),
        filters: PropTypes.instanceOf(Object),
        pageLoadedOnce: PropTypes.bool,
        isLoading: PropTypes.bool,
        isLoadingType: PropTypes.bool,
        adultTeamClubs: PropTypes.shape({
            hits: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
            total: PropTypes.number.isRequired,
            totalAllowed: PropTypes.number.isRequired,
        }),
        camps: PropTypes.shape({
            hits: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
            total: PropTypes.number.isRequired,
            totalAllowed: PropTypes.number.isRequired,
        }),
        clubs: PropTypes.shape({
            hits: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
            total: PropTypes.number.isRequired,
            totalAllowed: PropTypes.number.isRequired,
        }),
        collegeCircuits: PropTypes.shape({
            hits: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
            total: PropTypes.number.isRequired,
            totalAllowed: PropTypes.number.isRequired,
        }),
        colleges: PropTypes.shape({
            hits: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
            total: PropTypes.number.isRequired,
            totalAllowed: PropTypes.number.isRequired,
        }),
        events: PropTypes.shape({
            hits: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
            total: PropTypes.number.isRequired,
            totalAllowed: PropTypes.number.isRequired,
        }),
        flexLeagues: PropTypes.shape({
            hits: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
            total: PropTypes.number.isRequired,
            totalAllowed: PropTypes.number.isRequired,
        }),
        highSchools: PropTypes.shape({
            hits: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
            total: PropTypes.number.isRequired,
            totalAllowed: PropTypes.number.isRequired,
        }),
        juniorCircuits: PropTypes.shape({
            hits: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
            total: PropTypes.number.isRequired,
            totalAllowed: PropTypes.number.isRequired,
        }),
        juniorRegionals: PropTypes.shape({
            hits: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
            total: PropTypes.number.isRequired,
            totalAllowed: PropTypes.number.isRequired,
        }),
        paidHitClubs: PropTypes.shape({
            hits: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
            total: PropTypes.number.isRequired,
            totalAllowed: PropTypes.number.isRequired,
        }),
        paidHits: PropTypes.shape({
            hits: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
            total: PropTypes.number.isRequired,
            totalAllowed: PropTypes.number.isRequired,
        }),
        players: PropTypes.shape({
            hits: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
            total: PropTypes.number.isRequired,
            totalAllowed: PropTypes.number.isRequired,
        }),
        proTennisTour: PropTypes.shape({
            hits: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
            total: PropTypes.number.isRequired,
            totalAllowed: PropTypes.number.isRequired,
        }),
        teamLeagues: PropTypes.shape({
            hits: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
            total: PropTypes.number.isRequired,
            totalAllowed: PropTypes.number.isRequired,
        }),
    }),
    eventSearchConfig: PropTypes.instanceOf(Object).isRequired,
    playerSearchConfig: PropTypes.instanceOf(Object).isRequired,
    clubSearchConfig: PropTypes.instanceOf(Object).isRequired,
    isMobileWidth: PropTypes.bool.isRequired,
    isTabletWidth: PropTypes.bool.isRequired,
    showAds: PropTypes.bool.isRequired,
};

SearchResults.defaultProps = {
    eventResultsOptions: null,
    search: {
        filterInputs: {
            startDate: moment().subtract(2, 'year'),
            endDate: moment(),
        },
        filters: null,
        pageLoadedOnce: false,
        isLoading: false,
        adultTeamClubs: {
            hits: [],
            total: 0,
            totalAllowed: 0,
        },
        camps: {
            hits: [],
            total: 0,
            totalAllowed: 0,
        },
        clubs: {
            hits: [],
            total: 0,
            totalAllowed: 0,
        },
        colleges: {
            hits: [],
            total: 0,
            totalAllowed: 0,
        },
        collegeCircuits: {
            hits: [],
            total: 0,
            totalAllowed: 0,
        },
        events: {
            hits: [],
            total: 0,
            totalAllowed: 0,
        },
        flexLeagues: {
            hits: [],
            total: 0,
            totalAllowed: 0,
        },
        highSchools: {
            hits: [],
            total: 0,
            totalAllowed: 0,
        },
        juniorCircuits: {
            hits: [],
            total: 0,
            totalAllowed: 0,
        },
        juniorRegionals: {
            hits: [],
            total: 0,
            totalAllowed: 0,
        },
        paidHitClubs: {
            hits: [],
            total: 0,
            totalAllowed: 0,
        },
        paidHits: {
            hits: [],
            total: 0,
            totalAllowed: 0,
        },
        players: {
            hits: [],
            total: 0,
            totalAllowed: 0,
        },
        proTennisTour: {
            hits: [],
            total: 0,
            totalAllowed: 0,
        },
        teamLeagues: {
            hits: [],
            total: 0,
            totalAllowed: 0,
        },
    },
    updateFiltersApplied: () => { },
    applySearchFilters: () => { },
    changeFilterInputs: () => { },
    searchPageType: '',
    isPickleballSportFilterEnabled: false,
};

function mapStateToProps({ auth, naturalSearch }) {
    // Select only the sentinel — pulling the full slice causes a re-render
    // on every NL state change (loading/error/clarification), and the
    // component only reads naturalSearch?.appliedSentinel.
    return {
        auth,
        naturalSearchAppliedSentinel: naturalSearch?.appliedSentinel ?? 0,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getFeedPreferences: () => dispatch(getFeedPreferences()),

    };
}

export default withStatsig(connect(mapStateToProps, mapDispatchToProps)(SearchResults));
